export const routes = (parentName) => {
  return [
    {
      path: "doctor",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Doctor`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Doctor-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "special",
          name: `${parentName}-Doctor-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "deposit",
          name: `${parentName}-Doctor-List-Deposit`,
          component: () => import("./ListDeposit.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Doctor-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Doctor-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Doctor-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
